import { Component } from '@angular/core';

@Component({
  selector: 'app-participate',
  templateUrl: './participate.component.html',
  styleUrls: ['./participate.component.scss']
})
export class ParticipateComponent {

  openSameTab(ev: Event, href: string) {
    ev.preventDefault();                // evita navegação SPA
    window.location.assign(href);       // navega na mesma aba com reload
    // window.location.replace(href);   // se não quiser empilhar no histórico
  }

}
